module.exports = __webpack_public_path__ + "static/media/ins_winner.8618fc48.png";